import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseItemMultiplyOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-multiply-option';
import {useAppSelector} from '@/hooks';
import type {RGBA} from '@Utils/color.util';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

interface VideoBgMultiplyOptionProps {
  onClickColorFill(): void;
}

export function VideoBgMultiplyOption({...props}: VideoBgMultiplyOptionProps): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const videoDetails = currentPageBackground.details;

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  const onToggleMultiply = (): void => {
    void currentPage?.background.updateFromObject({
      details: {
        effects: {
          multiply: !videoDetails.effects.multiply,
        },
      },
    });
  };

  const onUpdateOpacity = (multiplyOpacity: number, undoable = true): void => {
    const multiplyColor = videoDetails.effects.multiplyColor.slice() as RGBA;
    multiplyColor[3] = multiplyOpacity;
    void currentPage?.background.updateFromObject(
      {
        details: {
          effects: {
            multiplyColor,
          },
        },
      },
      {undoable}
    );
  };

  return (
    <BaseItemMultiplyOption
      onClickColorFill={onClickColorFill}
      multiplyOpacity={videoDetails.effects.multiplyColor[3]}
      multiply={videoDetails.effects.multiply}
      multiplyColor={videoDetails.effects.multiplyColor}
      onToggleMultiply={onToggleMultiply}
      updateOpacity={onUpdateOpacity}
    />
  );
}
